var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useCallback, useEffect } from "react";
import { getUnixNow } from "realmsbase-common";
export var LOGGED_OUT_DEFAULT_ROUTE = "/login";
export var AuthContext = createContext({
    sessionToken: undefined,
    saveSessionToken: function (sessionToken) { },
    clearSessionToken: function () { },
});
/*
 * Stores the global auth data
 */
export var AuthProvider = function (_a) {
    var children = _a.children, _b = _a.storage, storage = _b === void 0 ? window.localStorage : _b;
    var _c = useState(false), hasFetchedSessionToken = _c[0], setHasFetchedSessionToken = _c[1];
    var _d = useState(undefined), sessionToken = _d[0], setSessionToken = _d[1];
    useEffect(function () {
        getSavedSessionToken(storage).then(function (e) {
            setSessionToken(e);
            setHasFetchedSessionToken(true);
        });
    }, []);
    var saveSessionToken = useCallback(function (sessionToken) {
        setSessionToken(sessionToken);
        storage.setItem("sessionToken", JSON.stringify(sessionToken));
    }, []);
    var clearSessionToken = useCallback(function () {
        setSessionToken(undefined);
        storage.removeItem("sessionToken");
    }, []);
    useEffect(function () {
        var subscribe = storage.subscribe, unsubscribe = storage.unsubscribe;
        if (subscribe && unsubscribe) {
            var callback_1 = function (key, value) {
                if (key === "sessionToken") {
                    setSessionToken(value ? JSON.parse(value) : undefined);
                }
            };
            subscribe(callback_1);
            return function () {
                unsubscribe(callback_1);
            };
        }
    }, []);
    return (_jsx(AuthContext.Provider, __assign({ value: {
            sessionToken: sessionToken,
            saveSessionToken: saveSessionToken,
            clearSessionToken: clearSessionToken,
        } }, { children: hasFetchedSessionToken ? children : null })));
};
// Get saved sessionToken
function getSavedSessionToken(storage) {
    return __awaiter(this, void 0, void 0, function () {
        var sessionTokenString, sessionToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, storage.getItem("sessionToken")];
                case 1:
                    sessionTokenString = _a.sent();
                    if (sessionTokenString === null) {
                        return [2 /*return*/, undefined];
                    }
                    sessionToken = JSON.parse(sessionTokenString);
                    // Check not expired
                    if (getUnixNow() > sessionToken.expiry) {
                        storage.removeItem("sessionToken");
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/, sessionToken];
            }
        });
    });
}
